module.exports = __webpack_public_path__ + "img/dot_white.6c382aa9.png";